import { useState, useEffect } from "react";
import {
  Typography,
  Button,
  TextField,
  Box, MenuItem,
  FormControl,
  InputLabel,
  Select, Divider, Autocomplete
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import ViewDataGridGrn from "../grid/ViewDataGridGrn";
import {SupbankData } from "../grid/GridDataGrn";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { SETTING_API_10, SETTING_API_11, SETTING_API_12, SUPPLIER_API_06, SUPPLIER_API_07 } from "../../api/ApiModel";
import { externalgetApi, externalpostApi } from "../../services/externalApis";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import SystemAlert from "../../components/common/SystemAlert";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ViewDataGridsup from "../grid/ViewDataGridsup";
function SupplierBank( {suprefcode, setSuprefcode}) {
  const theme = useTheme();
  const styles = useStyles(theme);
     const [datacountrty, setDatacountry] = useState(null);
  const navigate = useNavigate();
    const [alertOpen, setAlertOpen] = useState(false); // State to control alert visibility
    const [alertType, setAlertType] = useState("success"); // Type of alert (e.g., success, error, warning)
    const [alertMessage, setAlertMessage] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);
  const [data, setData] = useState(null);
  const [databank, setDatabank] = useState(null);
  const [databranch, setDatabranch] = useState(null);
  const [error, setError] = useState({});
   const SYS_USER = useSelector((state) => state.user) || {};
    const {   LOCCODE,STAFFMAPLOCODE, RESTCODE, USERNAME, COMPCODE } = SYS_USER.USER_PARAM || {};
 const [selectedBankCode, setSelectedBankCode] = useState("");
  const [selectedBranchCode, setSelectedBranchCode] = useState("");
const [selectedCompBankCode, setSelectedCompBankCode] = useState("");

const [isEdit, setIsEdit] = useState(false);


   const [selectedItemDetails, setSelectedItemDetails] = useState({
   countrycode: "",
  bankcode: "",
  bankbranchcode: "",
  accountno: "",
  swiftcode: "",
beneficiary: "",
  bankdetcode: "",
      isdefault: "N",
    });

const menuItems = [
  {
    text: "Edit",
    icon: <BorderColorOutlinedIcon />,
    onClick: (row) => handleItemClick(row, "Edit"), // Pass the whole row
  },

  {
    text: "Remove",
    icon: <DeleteOutlineIcon />,
    onClick: (row) => handleItemClick(row, "Delete"),
  },
];


       useEffect(() => {
      
      
          fetchDatasupbank();
        }, [selectedCompBankCode]);

    const fetchDatasupbank = async () => {
            try {
              const result = await externalgetApi(SETTING_API_11, "get", {
              
      COMPBANKCODE: selectedCompBankCode || "",
                STS: CON_STATUS_ACTIVE,
              });
      
              setDatabranch(result);
              console.log("result", result);
          
            } catch (err) {
              setError(err);
           
            }
          };

const handleItemClick = async (bankdetcode, action) => {
  if (action === "Edit" && data) {
    const bank = data.find((b) => b.bankdetcode === bankdetcode);
    if (bank) {
      setSelectedItemDetails({
        countrycode: bank.countrycode || "",
        bankcode: bank.bankcode || "",
        bankbranchcode: bank.bankbranchcode || "",
        accountno: bank.accountno || "",
        swiftcode: bank.swiftcode || "",
        bankdetcode: bank.bankdetcode || "",
        branchname: bank.branchname || "",
        compbankcode: bank.compbankcode || "",
        beneficiary: bank.beneficiary || "",
        isdefault: bank.isdefault || "",
      });
      setIsEdit(true);
      setSelectedBankCode(bank.bankcode || "");
      setSelectedCompBankCode(bank.compbankcode || "");
      setSelectedBranchCode(bank.bankbranchcode || "");
    }
  } else if (action === "Delete" && data) {
    // Soft delete: set STS to "D"
    try {
      const bank = data.find((b) => b.bankdetcode === bankdetcode);
      if (!bank) return;
      const payload = {
        ...bank,
        STS: "D",
      };
      await externalpostApi(SUPPLIER_API_07, payload);
      setAlertType("success");
      setAlertMessage("Deleted Successfully!");
      setAlertOpen(true);
      fetchDatasup(suprefcode);
    } catch (error) {
      setAlertType("error");
      setAlertMessage("Delete failed.");
      setAlertOpen(true);
    }
  }
};

   useEffect(() => {
 
 
     fetchDatasup();
   }, [setSuprefcode]);
 
    const fetchDatasup = async () => {
       try {
       const result = await externalgetApi(SUPPLIER_API_07, "get", {
  
 SUPREFCODE: suprefcode,
           STS: CON_STATUS_ACTIVE,
         });
         
 
         setData(result);
         setFilteredRows(result);
       console.log("result", result);
       
       } catch (err) {
         setError(err);
        
       }
     };
const handleInputChange = (e) => {
  const { name, value } = e.target;
  
  // Remove all leading spaces
  const cleanedValue = typeof value === "string" ? value.replace(/^\s+/, "") : value;
  const trimmedValue = typeof cleanedValue === "string" ? cleanedValue.trim() : cleanedValue;

  // Validate max length
  if (typeof cleanedValue === "string" && cleanedValue.length > 30) {
    setError((prevError) => ({
      ...prevError,
      [name]: "Input cannot exceed 30 characters.",
    }));
    return;
  }

  // Validate empty string
  if (typeof cleanedValue === "string" && trimmedValue === "") {
    setError((prevError) => ({
      ...prevError,
      [name]: "Input cannot be empty or just spaces.",
    }));
  } else {
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  }

  // Always update the value
  setSelectedItemDetails((prevDetails) => ({
    ...prevDetails,
    [name]: cleanedValue,
  }));
};

   const handlenumInputChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = typeof value === "string" ? value.trim() : value;
  
    // Prevent initial space only
    if (typeof value === "string" && value.length === 1 && value[0] === " ") {
      return;
    }
  
// Only allow numbers (no decimals)
const isNumeric = /^[0-9]*$/.test(value);
if (!isNumeric) {
  setError((prevError) => ({
    ...prevError,
    [name]: "Input must contain only numbers.",
  }));
  return; // Prevent state update if input is not numeric
}
  
    // Clear the value if it is "0" when focused
    if (value === "0") {
      setSelectedItemDetails((prevDetails) => ({
        ...prevDetails,
        [name]: "",
      }));
      return;
    }
  
    // Clear error if input is valid
    setError((prevError) => ({
      ...prevError,
      [name]: "",
    }));
  
    // Always update the value
    setSelectedItemDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };

     useEffect(() => {
      const fetchData = async () => {
        try {
          const result = await externalgetApi(SETTING_API_12, "get", {
          
          });
  
          setDatacountry(result);
          console.log("result", result);
     
        } catch (err) {
          setError(err);
       
        }
      };
  
      fetchData();
    }, []);

     useEffect(() => {
        const fetchData = async () => {
          try {
            const result = await externalgetApi(SETTING_API_10, "get", {
              COMPCODE,
               
    
    
              STS: CON_STATUS_ACTIVE,
            });
    
            setDatabank(result);
            console.log("result", result);
        
          } catch (err) {
            setError(err);
           
          }
        };
    
        fetchData();
      }, []);




      
const bankOptions = databank
  ? databank
      .filter((item) => 
        !selectedItemDetails.countrycode || item.countrycode === selectedItemDetails.countrycode
      )
      .map((item) => ({
        label: item.bankname,
        value: item.compbankcode,
        bankcode: item.bankcode,
        compbankcode: item.compbankcode,
        countrycode: item.countrycode,
      }))
  : [];

// const branchOptions = databranch
//   ? databranch.map((item) => ({
//       label: item.branchname, // or the correct field for branch name
//       value: item.branchcode, // or the correct field for branch code
//       bankbranchcode: item.branchcode, // Add bankbranchcode field
//     }))
//   : [];


const branchOptionsRaw = databranch
  ? databranch.map((item) => ({
      label: item.branchname,
      value: item.branchcode,
      bankbranchcode: item.branchcode,
    }))
  : [];

const editBranch =
  isEdit && selectedItemDetails.branchname && selectedItemDetails.bankbranchcode
    ? [{
        label: selectedItemDetails.branchname,
        value: selectedItemDetails.bankbranchcode,
        bankbranchcode: selectedItemDetails.bankbranchcode,
      }]
    : [];

const branchOptions = [
  ...branchOptionsRaw,
  ...editBranch.filter(
    (editOpt) => !branchOptionsRaw.some((opt) => opt.value === editOpt.value)
  ),
];
 

    // After fetching setDatacountry(result), prepare options:
  const countryOptions = datacountrty
    ? datacountrty.map((item) => ({
        label: item.country,
        value: item.countrycode,
      }))
    : [];

    const handleClear = () => {
  setSelectedItemDetails({
    countrycode: "",
    bankcode: "",
    bankbranchcode: "",
    accountno: "",
    swiftcode: "",
    beneficiaryname: "",
    bankdetcode: "",
    bankname: "",
    branchname: "",
    compbankcode: "",
    beneficiary: "",
  });
  setSelectedBankCode("");
  setSelectedBranchCode("");
  setSelectedCompBankCode("");
  setIsEdit(false);
  
};

    const handleConfirmClick = async () => {

    
    const requiredFields = [
      {
        name: "countrycode",
        label: "Country",
        value: selectedItemDetails.countrycode,
      },
      {
        name: "bankcode",
        label: "Bank",
        value: String(selectedItemDetails.bankcode),
      },
      {
        name:"bankbranchcode",
        label: "Branch",
        value: selectedItemDetails.bankbranchcode,
      },
      
      {
        name: "swiftcode",
        label: "Swift Code",
        value: selectedItemDetails.swiftcode,
      },
      {
        name: "beneficiary",
        label: "Beneficiary Name",
        value: selectedItemDetails.beneficiary,
      },
      {
        name: "accountno",
        label: "Account Number",
        value: selectedItemDetails.accountno,
      },
      {
        name: "isdefault",
        label: "Is Default",
        value: selectedItemDetails.isdefault,
      },
    ];

    const missingRequiredFields = requiredFields.filter(
      (field) => !field.value
    );
    if (missingRequiredFields.length > 0) {
      const newError = {};
      missingRequiredFields.forEach((field) => {
        newError[field.name] = `${field.label} is required.`;
      });
      setError(newError);

      const missingFieldLabels = missingRequiredFields
        .map((field) => field.label)
        .join(", ");
      //  const errorMessage = `Required fields: ${missingFieldLabels}.`;
      const errorMessage = `Please Fill All the Required Fields.`;
      setAlertType("error");
      setAlertMessage("Please Fill All the Required Fields.");
      setAlertOpen(true); // Open the alert
    
      return;
    }

     if (selectedItemDetails.isdefault === "Y") {
    const alreadyDefault = (data || []).some(
      (item) =>
        item.isdefault === "Y" &&
        // If editing, allow the current record to remain default
        item.bankdetcode !== selectedItemDetails.bankdetcode
    );
    if (alreadyDefault) {
      setAlertType("error");
      setAlertMessage("Only one bank can be set as default (Yes).");
      setAlertOpen(true);
      return;
    }
  }
    // if (data) {
    //   const isDuplicate = data.some((item) => {
    //     if (
    //       item.industrycode !==  selectedItemDetails.industrycode &&
    //       item.industryname.toLowerCase() === industryname.toLowerCase()
    //     ) {
    //       return true;
    //     } else {
    //       return false;
    //     }
    //   });

    //   if (isDuplicate) {
    //     setAlertMessage("Industry Already Exists.");
    //     setAlertType("warning");

    //     setAlertOpen(true); // Open the alert
    //     return;
    //   }
    // }

   // const BRAND_CODE = selectedItem ? (selectedItem.industrycode) : 0;
  //  console.log("Brand Code:", BRAND_CODE);

    const staticValues = {
 SUPREFCODE: suprefcode,

     ENDATE: new Date().toISOString(),
      expdate: new Date().toISOString().slice(0, 10), 
      STS: CON_STATUS_ACTIVE,
      ENUSER: USERNAME,
    };

    const payload = {
      ...selectedItemDetails,
      ...staticValues,
    bankdetcode: selectedItemDetails.bankdetcode || 0,
    };

    try {
      console.log("Payload for API call:", payload);
      const responseData = await externalpostApi(SUPPLIER_API_07, payload);
      console.log("Success:", responseData);
      setAlertMessage(
        `${isEdit ? "Updated Successfully!" : "Created Successfully!"}`
      );
      setAlertType("success");

      setAlertOpen(true);
        fetchDatasup(suprefcode);
    handleClear()
      setIsEdit(false);
      
    } catch (error) {
      console.error("Error:", error);
      setAlertType("error");
      setAlertMessage("An unexpected error occurred.");
      setAlertOpen(true); // Open the alert
    }
    



  };

  

  useEffect(() => {
  console.log("Selected Branch Code:", selectedBranchCode);
}, [selectedBranchCode]);

  return (
    <>
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{ ...styles.add_form_page_container, mb: 2 }}
      >
        <Grid container spacing={2} mt={2}>
          <Grid item size={{ xs: 12, sm: 12, md: 2, lg: 2, xl: 2 }}>
            <Typography sx={styles.supplier_sub_title_text}>
              Add Bank
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            size={{ xs: 12, sm: 12, md: 10, lg: 10, xl: 10 }}
          >
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
            
  <Autocomplete
    options={countryOptions}
    getOptionLabel={(option) => option.label || ""}
       disableClearable
    value={
      countryOptions.find(
        (opt) => opt.value === selectedItemDetails.countrycode
      ) || null
    }
    onChange={(_, newValue) => {
      setSelectedItemDetails((prev) => ({
        ...prev,
        countrycode: newValue ? newValue.value : "",
        country: newValue ? newValue.label : "",
      }));
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Country"
        variant="outlined"
        size="small"
        required
        error={!!error.countrycode}
        helperText={error.countrycode}
        FormHelperTextProps={{
          sx: { fontSize: "12px", color: "red" },
        }}
      />
    )}
    fullWidth
    size="small"
  />
</Grid>
           
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
     

<Autocomplete
   options={bankOptions}
  getOptionLabel={(option) => option.label || ""}
     disableClearable
  value={
    bankOptions.find((opt) => opt.bankcode === selectedBankCode) || null
  }
  onChange={(_, newValue) => {
    setSelectedItemDetails((prev) => ({
      ...prev,
      bankcode: newValue ? newValue.bankcode : "",
      compbankcode: newValue ? newValue.compbankcode : "",
      bankname: newValue ? newValue.label : "",
      bankbranchcode: "",
      branchname: "",
    }));
    setSelectedBankCode(newValue ? newValue.bankcode : "");
    setSelectedCompBankCode(newValue ? newValue.compbankcode : "");
    setSelectedBranchCode("");
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Bank"
      variant="outlined"
      size="small"
      required
      error={!!error.bankcode}
      helperText={error.bankcode}
      FormHelperTextProps={{
        sx: { fontSize: "12px", color: "red" },
      }}
    />
  )}
  fullWidth
  size="small"
/>

            </Grid>
         <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
<Autocomplete
  options={branchOptions}
  getOptionLabel={(option) => option.label || ""}
     disableClearable
value={
  branchOptions.find(
    (opt) =>
      String(opt.value) === String(selectedBranchCode) ||
      String(opt.value) === String(selectedItemDetails.bankbranchcode)
  ) || null
}
  onChange={(_, newValue) => {
    setSelectedBranchCode(newValue ? newValue.value : "");
    setSelectedItemDetails((prev) => ({
      ...prev,
      bankbranchcode: newValue ? newValue.value : "",
      branchname: newValue ? newValue.label : "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Branch"
      variant="outlined"
      size="small"
      required
      error={!!error.bankbranchcode}
      helperText={error.bankbranchcode}
      FormHelperTextProps={{
        sx: { fontSize: "12px", color: "red" },
      }}
    />
  )}
  fullWidth
  size="small"
/>
</Grid>

            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="swift-code"
                label="Swift Code"
                variant="outlined"
                fullWidth
                size="small"
                required
                name="swiftcode"
                value={selectedItemDetails.swiftcode}
                onChange={handleInputChange}
                error={!!error.swiftcode}
                helperText={error.swiftcode}
                  FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                label="Beneficiary Name"
                variant="outlined"
                fullWidth
                size="small"
                required
                name="beneficiary"
                value={selectedItemDetails.beneficiary}

                onChange={handleInputChange}
                error={!!error.beneficiary}
                helperText={error.beneficiary}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>
            {/* <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
  id="bank-code"
  label="Bank Code"
  variant="outlined"
  fullWidth
  size="small"

  name="bankcode"
  value={selectedBankCode}
  // onChange={handleInputChange} // keep this commented to make it read-only

  FormHelperTextProps={{
    sx: { fontSize: "12px", color: "red" },
  }}
/>
            </Grid>
           <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
 <TextField
  id="bank-code"
  label="Branch Code"
  variant="outlined"
  fullWidth
  size="small"
  name="bankbranchcode"
  value={selectedItemDetails.bankbranchcode || ""}
  FormHelperTextProps={{
    sx: { fontSize: "12px", color: "red" },
  }}
  InputProps={{ readOnly: true }}
/>
</Grid> */}
            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
              <TextField
                id="bank-code"
                label="Account Number"
                variant="outlined"
                fullWidth
                size="small"
                required
                name="accountno"
                value={selectedItemDetails.accountno}
                onChange={handlenumInputChange}
                error={!!error.accountno}
                helperText={error.accountno}
                FormHelperTextProps={{
                  sx: { fontSize: "12px", color: "red" }, // Customize font size and color
                }}
              />
            </Grid>

            <Grid item size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
  <Autocomplete
    options={[
      { label: "Yes", value: "Y" },
      { label: "No", value: "N" },
    ]}
    getOptionLabel={(option) => option.label}
       disableClearable
    value={
      [{ label: "Yes", value: "Y" }, { label: "No", value: "N" }]
        .find(opt => opt.value === selectedItemDetails.isdefault) || null
    }
    onChange={(_, newValue) => {
      setSelectedItemDetails(prev => ({
        ...prev,
        isdefault: newValue ? newValue.value : "",
      }));
    }}
    renderInput={(params) => (
      <TextField
        {...params}
        label="Is Default"
        variant="outlined"
        size="small"
      required
        name="isdefault"
        error={!!error.isdefault}
        helperText={error.isdefault}
        FormHelperTextProps={{
          sx: { fontSize: "12px", color: "red" },
        }}
      />
    )}
    fullWidth
    size="small"
  />
</Grid>
          </Grid>
        </Grid>
      </Box>
      <Box sx={styles.add_form_page_button_box}>
        <Button
          variant="outlined"
          size="medium"
          sx={{ ...styles.btn_secondary, ...styles.btn_add_cancel }}
          onClick={handleClear}
        >
          Clear
        </Button>
        <Button
          variant="contained"
          size="medium"
          sx={{ ...styles.btn_primary, ...styles.btn_add_confirm }}
          onClick={handleConfirmClick}
        >
        {isEdit ? "Modify" : "Add"}
        </Button>
      </Box>

      <Box sx={styles.view_page_container}>
        <Typography sx={styles.supplier_sub_title_text}>
          Bank Details
        </Typography>
        <Divider sx={{ mb: 2 }} />
     <ViewDataGridsup
  columns={SupbankData.columns}
  rows={(filteredRows || []).map((row) => ({
    ...row,
    id: row.bankdetcode || Math.random(), // Ensure each row has a unique id
  }))}
  menuItems={menuItems}
  tabletitle={SupbankData.name}
  gridid="bankdetcode"
  sx={styles.view_data_grid_page}
/>


        <SystemAlert
          open={alertOpen}
          type={alertType}
          message={alertMessage}
          onClose={() => setAlertOpen(false)}
        />
      </Box>
      {/* <Divider sx={{ my: 2 }} /> */}
     
    </>
  );
}

export default SupplierBank;
